import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {Injectable, ModuleWithProviders, NgModule, Optional, SkipSelf} from '@angular/core';
import {AppAccessControlService, AppRoleProvider} from '@app/security';
import {APP_AUTH_OPTIONS, AppAuthService} from '@app/auth';
import {map} from 'rxjs/operators';
import {SessionService} from './utils/session.service';
import {throwIfAlreadyLoaded} from './module-import-guard';
import {AnalyticsService, LayoutService, PlayerService, SeoService} from './utils';
import {ApiService} from './utils/api.service';
import {AuthHttpInterceptor} from './utils/auth-http.interceptor';

@Injectable()
export class AppSimpleRoleProvider extends AppRoleProvider {
	constructor(private readonly authService: AppAuthService) {
		super();
	}

	getRole() {
		return this.authService.isAuthenticated().pipe(
			map(authenticated => (authenticated ? 'user' : 'guest')),
		);
	}
}

export const APP_CORE_PROVIDERS = [
	{provide: APP_AUTH_OPTIONS, useValue: {}},
	{provide: AppRoleProvider, useClass: AppSimpleRoleProvider},
	{provide: HTTP_INTERCEPTORS, useClass: AuthHttpInterceptor, multi: true},
	AppAccessControlService,
	AnalyticsService,
	LayoutService,
	PlayerService,
	SeoService,
	ApiService,
	SessionService,
];

@NgModule({})
export class CoreModule {
	constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
		throwIfAlreadyLoaded(parentModule, 'CoreModule');
	}

	static forRoot(): ModuleWithProviders<CoreModule> {
		return {
			ngModule: CoreModule,
			providers: [...APP_CORE_PROVIDERS],
		};
	}
}
